var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: {
        title: "编辑模板：" + (_vm.record ? _vm.record.title : ""),
        width: 600,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading,
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-form",
        { attrs: { form: _vm.form } },
        [
          _c(
            "a-form-item",
            {
              attrs: {
                label: "票据标题",
                labelCol: _vm.labelCol,
                wrapperCol: _vm.wrapperCol,
              },
            },
            [
              _c("a-input", {
                directives: [
                  {
                    name: "decorator",
                    rawName: "v-decorator",
                    value: [
                      "title",
                      { rules: [{ required: true, message: "请输入标题" }] },
                    ],
                    expression:
                      "['title', { rules: [{ required: true, message: '请输入标题' }] }]",
                  },
                ],
              }),
            ],
            1
          ),
          _c(
            "a-form-item",
            {
              attrs: {
                label: "表头显示",
                labelCol: _vm.labelCol,
                wrapperCol: _vm.wrapperCol,
              },
            },
            [
              _c(
                "a-checkbox-group",
                {
                  directives: [
                    {
                      name: "decorator",
                      rawName: "v-decorator",
                      value: ["header", {}],
                      expression: "['header', {}]",
                    },
                  ],
                },
                [
                  _c("a-checkbox", { attrs: { value: "area" } }, [
                    _vm._v("区域"),
                  ]),
                  _c("a-checkbox", { attrs: { value: "table" } }, [
                    _vm._v("桌台"),
                  ]),
                  _c("a-checkbox", { attrs: { value: "people" } }, [
                    _vm._v("人数"),
                  ]),
                  _c("a-checkbox", { attrs: { value: "orderNo" } }, [
                    _vm._v("单号"),
                  ]),
                  _c("a-checkbox", { attrs: { value: "time" } }, [
                    _vm._v("时间"),
                  ]),
                  _c("a-checkbox", { attrs: { value: "operator" } }, [
                    _vm._v("操作员"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-form-item",
            {
              attrs: {
                label: "菜品行显示",
                labelCol: _vm.labelCol,
                wrapperCol: _vm.wrapperCol,
              },
            },
            [
              _c(
                "a-checkbox-group",
                {
                  directives: [
                    {
                      name: "decorator",
                      rawName: "v-decorator",
                      value: ["item", {}],
                      expression: "['item', {}]",
                    },
                  ],
                },
                [
                  _c("a-checkbox", { attrs: { value: "name" } }, [
                    _vm._v("名称"),
                  ]),
                  _c("a-checkbox", { attrs: { value: "quantity" } }, [
                    _vm._v("数量"),
                  ]),
                  _c("a-checkbox", { attrs: { value: "unit" } }, [
                    _vm._v("单位"),
                  ]),
                  _c("a-checkbox", { attrs: { value: "options" } }, [
                    _vm._v("做法"),
                  ]),
                  _c("a-checkbox", { attrs: { value: "remark" } }, [
                    _vm._v("备注"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-form-item",
            {
              attrs: {
                label: "字号",
                labelCol: _vm.labelCol,
                wrapperCol: _vm.wrapperCol,
              },
            },
            [
              _vm._v("\n      标题 "),
              _c(
                "a-select",
                {
                  directives: [
                    {
                      name: "decorator",
                      rawName: "v-decorator",
                      value: ["titleSize", { initialValue: 2 }],
                      expression: "['titleSize', { initialValue: 2 }]",
                    },
                  ],
                  staticStyle: { width: "90px" },
                },
                [
                  _c("a-select-option", { attrs: { value: 1 } }, [
                    _vm._v("标准"),
                  ]),
                  _c("a-select-option", { attrs: { value: 2 } }, [
                    _vm._v("倍大"),
                  ]),
                ],
                1
              ),
              _c("span", { staticStyle: { margin: "0 8px" } }, [_vm._v("/")]),
              _vm._v("\n      菜品 "),
              _c(
                "a-select",
                {
                  directives: [
                    {
                      name: "decorator",
                      rawName: "v-decorator",
                      value: ["itemSize", { initialValue: 1 }],
                      expression: "['itemSize', { initialValue: 1 }]",
                    },
                  ],
                  staticStyle: { width: "90px" },
                },
                [
                  _c("a-select-option", { attrs: { value: 1 } }, [
                    _vm._v("标准"),
                  ]),
                  _c("a-select-option", { attrs: { value: 2 } }, [
                    _vm._v("倍大"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-form-item",
            {
              attrs: {
                label: "分隔线字符",
                labelCol: _vm.labelCol,
                wrapperCol: _vm.wrapperCol,
              },
            },
            [
              _c("a-input", {
                directives: [
                  {
                    name: "decorator",
                    rawName: "v-decorator",
                    value: ["divider", { initialValue: "-" }],
                    expression: "['divider', { initialValue: '-' }]",
                  },
                ],
                staticStyle: { width: "120px" },
              }),
            ],
            1
          ),
          _c(
            "a-form-item",
            {
              attrs: {
                label: "按分类分区",
                labelCol: _vm.labelCol,
                wrapperCol: _vm.wrapperCol,
              },
            },
            [
              _c("a-switch", {
                directives: [
                  {
                    name: "decorator",
                    rawName: "v-decorator",
                    value: [
                      "groupByCategory",
                      { valuePropName: "checked", initialValue: false },
                    ],
                    expression:
                      "['groupByCategory', { valuePropName: 'checked', initialValue: false }]",
                  },
                ],
              }),
              _c(
                "span",
                { staticStyle: { "margin-left": "8px", color: "#999" } },
                [_vm._v("开启后菜品按分类分组显示")]
              ),
            ],
            1
          ),
          _c(
            "a-form-item",
            {
              attrs: {
                label: "尾部文字",
                labelCol: _vm.labelCol,
                wrapperCol: _vm.wrapperCol,
              },
            },
            [
              _c("a-textarea", {
                directives: [
                  {
                    name: "decorator",
                    rawName: "v-decorator",
                    value: ["footer"],
                    expression: "['footer']",
                  },
                ],
                attrs: {
                  rows: 2,
                  placeholder: "如：谢谢惠顾 / 关注公众号（留空不打印）",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }